import { useState, useEffect, useRef } from 'react'

export const useNearScreen = () => {
  const [show, setShow] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    Promise.resolve('IntersectionObserver' in window ? window.IntersectionObserver : import('intersection-observer')
    ).then(() => {
      const options = {
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.3
      }
      const observer = new window.IntersectionObserver(entries => {
        const { isIntersecting } = entries[0]
        if (isIntersecting) {
          setShow(true)
          observer.disconnect()
        }
      }, options)
      observer.observe(ref.current)
    })
  }, [ref])

  return [show, ref]
}
